<template>
    <a-modal :visible="visible" :title="state.title" @cancel="handleModalCancel" width="70%" :destroy-on-close="true"
        :footer="null">

        <AForm ref="formRef" class="myform" :model="form" :rules="state.rules" @finish="handleOk"
            :wrapper-col="{ span: 14 }" :scroll-to-first-error="true">

            <!-- kode -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Kode" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }" required
                        name="code" has-feedback>
                        <a-input placeholder="Kode" width="100%" v-model:value="form.code" :disabled="form.readOnly" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- nama -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Nama segment" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }" required
                        name="name" has-feedback>
                        <AInput placeholder="name segment project" v-model:value="form.name"
                            :disabled="form.readOnly" />
                    </AFormItem>
                </ACol>
            </ARow>

            <ARow v-if="!form.readOnly" class="form-row" type="flex" justify="end">
                <ACol>
                    <AFormItem>
                        <a-button type="primary" html-type="submit" :loading="form.busy" :disabled="form.busy">{{
                            !form.id ? 'Simpan' : 'Perbarui'
                            }}</a-button>
                    </AFormItem>
                </ACol>
            </ARow>
        </AForm>

        <div v-if="form.errors.any()">
            <ASpace>
                <AAlert v-for="(item, index) in form.errors.all()" type="error" :key="index" :message="item.message"
                    banner closable @close="form.clear()" />
            </ASpace>
        </div>
    </a-modal>
</template>
<script>
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
} from 'vue'
import Form from 'vform'
import apiClient from '@/services/axios'
import { Modal, Select, message } from 'ant-design-vue'
import includes from 'lodash/includes'

export default defineComponent({
    components: {
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
                readOnly: false,
            }),
        },
    },
    emits: ['success', 'update:visible', 'update:item'],

    setup(props, { emit }) {
        const form = reactive(new Form({
            id: props.item.id,
            code: null,
            name: null,
        }))

        const formRef = ref();

        const state = reactive({
            title: 'Lihat Segment Project',
            endpoint: '/api/derivatives/segment-projects',
            data: [],
            page: 1,
            per_page: 1,
            total: 0,
            loading: false,
            rules: {
                code: [
                    {
                        required: true,
                        message: 'Kode tidak boleh kosong!',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: 'Nama segment tidak boleh kosong!',
                    },
                ],
            },
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const handleOk = async () => {

            // validation form
            await formRef.value.validate()
                .catch(() => { });

            if (!form.id) {
                form.post(state.endpoint)
                    .then(({ data }) => {
                        message.success('Berhasil menyimpan')

                        handleModalCancel()
                        emit('success', data)
                    })
                    .catch(() => {
                        message.error('Gagal menyimpan data')
                    })
            } else {
                form.put(`${state.endpoint}/${form.id}`)
                    .then(({ data }) => {
                        message.success('Berhasil memperbarui')

                        handleModalCancel()
                        emit('success', data)
                    })
                    .catch(() => {
                        message.error('Gagal menyimpan data')
                    })
            }

        }

        // fetch by id
        const fetchByID = (id) => {
            apiClient
                .get(`${state.endpoint}/${id}`)
                .then(({ data }) => {
                    form.code = data.code
                    form.name = data.name
                })
                .catch(error => console.error({ failure: error }))
        }

        // handle func vue
        onMounted(() => {
            if (!form.id) {
                form.reset()
            } else {
                fetchByID(props.item.id)
            }

            form.readOnly = props.item.readOnly

            if (!props.item.readOnly) {
                state.title = `${!form.id ? 'Tambah' : 'Edit'} Segment Project`
            }
        })

        return {
            formRef,
            handleOk,
            form,
            state,
            handleModalCancel,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
